export const ProcessHeader = () => (
    <section className="relative pt-36 sm:pt-44 pb-4 text-center">
        <div
            className="pointer-events-none absolute inset-0 opacity-[0.04]"
            style={{
                backgroundImage:
                    "linear-gradient(#000 1px, transparent 1px), linear-gradient(90deg, #000 1px, transparent 1px)",
                backgroundSize: "64px 64px",
            }}
        />
        <div className="relative max-w-3xl mx-auto px-5 sm:px-8">
            <span className="font-mono text-xs tracking-[-0.01em] text-zinc-500 border border-black/10 rounded-full px-3.5 py-1.5 inline-flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
                HOW WE AUTOMATE SMES
            </span>
            <h1
                data-testid="process-headline"
                className="font-mono tracking-[-0.01em] text-black font-semibold leading-[1.05] text-4xl sm:text-5xl lg:text-6xl mt-6"
            >
                The 5-Phase Automation Delivery Workflow
            </h1>
            <p className="font-body text-base sm:text-lg text-black/60 mt-6 leading-relaxed">
                See how we map, secure, orchestrate, and validate your business
                data. This interactive blueprint details our exact delivery
                journey — from discovery to go-live — optimised for Malaysian
                compliance and government grant co-funding.
            </p>
        </div>
    </section>
);
